import Home from "./pages";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./assets/css/style.css";
import Detail from "./pages/Detail";
function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Detail/:id" element={<Detail />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
